import { render, staticRenderFns } from "./DevisTypesBATTH.vue?vue&type=template&id=04022987&scoped=true"
import script from "./DevisTypesBATTH.vue?vue&type=script&lang=js"
export * from "./DevisTypesBATTH.vue?vue&type=script&lang=js"
import style0 from "./DevisTypesBATTH.vue?vue&type=style&index=0&id=04022987&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04022987",
  null
  
)

export default component.exports